export const PendingSubscriptions = [
    {
        id: 1,
        productTitle: 'Customer Support',
        subscriptionName: 'Customer Support',
        domain: '',
        timeSubscriptionStart: 1709621401,
        timeSubscriptionEnd: 0,
        currentVersion: '',
        installedVersion: '',
        status: 'Not Created',
        userId: 5,
        timeClientInstallation: 0,
        timeClientUpdate: 0,
        limitBy: 'Not Set',
        invoiceId: 315,
        customerInfo: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            organization: 'Noman Co..',
            fullName: 'Noman Gazi',
            demo: true
        },
        demo: true
    },
    {
        id: 2,
        productTitle: 'Migration',
        subscriptionName: 'Migration',
        domain: '',
        timeSubscriptionStart: 1709621401,
        timeSubscriptionEnd: 0,
        currentVersion: '',
        installedVersion: '',
        status: 'Not Created',
        userId: 5,
        timeClientInstallation: 0,
        timeClientUpdate: 0,
        limitBy: 'Not Set',
        invoiceId: 315,
        customerInfo: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            organization: 'Noman Co..',
            fullName: 'Noman Gazi',
            demo: true
        },
        demo: true
    },
    {
        id: 3,
        productTitle: 'Installation',
        subscriptionName: 'Installation',
        domain: '',
        timeSubscriptionStart: 1709621401,
        timeSubscriptionEnd: 0,
        currentVersion: '',
        installedVersion: '',
        status: 'Not Created',
        userId: 5,
        timeClientInstallation: 0,
        timeClientUpdate: 0,
        limitBy: 'Not Set',
        invoiceId: 315,
        customerInfo: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            organization: 'Noman Co..',
            fullName: 'Noman Gazi',
            demo: true
        },
        demo: true
    },
    {
        id: 4,
        productTitle: 'Evaluation ',
        subscriptionName: 'Evaluation ',
        domain: '',
        timeSubscriptionStart: 1709621401,
        timeSubscriptionEnd: 0,
        currentVersion: '',
        installedVersion: '',
        status: 'Not Created',
        userId: 5,
        timeClientInstallation: 0,
        timeClientUpdate: 0,
        limitBy: 'Not Set',
        invoiceId: 315,
        customerInfo: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            organization: 'Noman Co..',
            fullName: 'Noman Gazi',
            demo: true
        },
        demo: true
    }
];
export default null;
